// extracted by mini-css-extract-plugin
export default {"ag-styles":"h_g","policyPage":"h_R","introduction":"h_S","policyList":"h_T","settingsButton":"h_V"};